import { createFileRoute } from "@tanstack/react-router";
import SslCheckerPage from "@/pages/SslCheckerPage";

export const Route = createFileRoute("/tools/ssl-checker")({
  component: SslCheckerPage,
});
